module.exports = __webpack_public_path__ + "static/img/stuck-im-neubau_3.6e23832.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stuck-im-neubau_3.jpg
// module id = ca6e
// module chunks = 1